var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannerHelpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 49.5C103 76.8381 80.8381 99 53.5 99C26.1619 99 4 76.8381 4 49.5C4 22.1619 26.1619 0 53.5 0C80.8381 0 103 22.1619 103 49.5Z",
    fill: "#CF4520"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9243 53.8696C68.1717 56.4992 66.762 58.894 64.8278 60.8281C62.8937 62.7622 60.499 64.172 57.8693 64.9246M57.8693 34.0754C60.5028 34.8205 62.9015 36.2277 64.8368 38.163C66.772 40.0982 68.1793 42.497 68.9243 45.1304M38.0752 45.1304C38.8278 42.5008 40.2376 40.106 42.1717 38.1719C44.1058 36.2378 46.5005 34.828 49.1302 34.0754M49.1302 64.9246C46.4967 64.1795 44.098 62.7723 42.1627 60.837C40.2275 58.9018 38.8203 56.5031 38.0752 53.8696",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.902 53.5929C81.0162 59.7256 78.17 65.4072 73.7885 69.7887C69.4069 74.1702 63.7254 77.0165 57.5927 77.9022M57.5927 21.0979C63.7254 21.9837 69.4069 24.8299 73.7885 29.2115C78.17 33.593 81.0162 39.2745 81.902 45.4072M25.0977 45.4072C25.9834 39.2745 28.8297 33.593 33.2112 29.2115C37.5927 24.8299 43.2743 21.9837 49.407 21.0979M49.407 77.9022C43.2743 77.0165 37.5927 74.1702 33.2112 69.7887C28.8297 65.4072 25.9834 59.7256 25.0977 53.5929",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9565 62.6088H52.0434C50.4346 62.6088 49.1304 63.913 49.1304 65.5218V78.6305C49.1304 80.2393 50.4346 81.5435 52.0434 81.5435H54.9565C56.5653 81.5435 57.8695 80.2393 57.8695 78.6305V65.5218C57.8695 63.913 56.5653 62.6088 54.9565 62.6088Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6306 45.1305H69.5219C67.9131 45.1305 66.6089 46.4347 66.6089 48.0435V50.9566C66.6089 52.5654 67.9131 53.8696 69.5219 53.8696H82.6306C84.2395 53.8696 85.5437 52.5654 85.5437 50.9566V48.0435C85.5437 46.4347 84.2395 45.1305 82.6306 45.1305Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4783 45.1305H24.3696C22.7608 45.1305 21.4565 46.4347 21.4565 48.0435V50.9566C21.4565 52.5654 22.7608 53.8696 24.3696 53.8696H37.4783C39.0871 53.8696 40.3913 52.5654 40.3913 50.9566V48.0435C40.3913 46.4347 39.0871 45.1305 37.4783 45.1305Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9565 17.4565H52.0434C50.4346 17.4565 49.1304 18.7608 49.1304 20.3696V33.4783C49.1304 35.0871 50.4346 36.3913 52.0434 36.3913H54.9565C56.5653 36.3913 57.8695 35.0871 57.8695 33.4783V20.3696C57.8695 18.7608 56.5653 17.4565 54.9565 17.4565Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerHelpIcon);
export default __webpack_public_path__ + "static/media/planner-help-icon.cdff722bb1e824e7cd68fed0b7181745.svg";
export { ForwardRef as ReactComponent };